import {
  GET_SYSTEM_PARAMETERS,
  GET_SYSTEM_PARAMETERS_FAILED,
  GET_SYSTEM_PARAMETERS_SUCCESS,
  SAVE_SYSTEM_PARAMETERS,
  SAVE_SYSTEM_PARAMETERS_FAILED,
  SAVE_SYSTEM_PARAMETERS_SUCCESS,
  SYSTEM_PARAMETERS_NOT_FOUND,
} from './constants';

const initialState = {
  currentSystemParameters: null,
  error: null,
  loading: false,
};

const systemParametersReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_SYSTEM_PARAMETERS:
    case SAVE_SYSTEM_PARAMETERS:
      return { ...state, loading: true };
    case GET_SYSTEM_PARAMETERS_SUCCESS:
    case SAVE_SYSTEM_PARAMETERS_SUCCESS:
      return { ...state, currentSystemParameters: action.payload.data, loading: false };
    case SYSTEM_PARAMETERS_NOT_FOUND:
      return { ...state, ...initialState };
    case GET_SYSTEM_PARAMETERS_FAILED:
    case SAVE_SYSTEM_PARAMETERS_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    default:
      return state;
  }
};

export default systemParametersReducer;
